<div class="bestwallet">
  <div class="content">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <p class="text-center mb-md-0 lh-1 font-22 font-md-28 fw-bold text-black">{{ 'nowallet_modal.need_wallet' | translate }}</p>
      <p class="text-center d-block d-md-none mb-3 mb-md-0 font-14 text-black fw-bold">{{ 'nowallet_modal.wallet_desc' | translate }}</p>
      <svg-icon src="/assets/images/bestwallet_modal/modal_close.svg" class="cursor-pointer modalClose" (click)="modalRef.hide()"></svg-icon>
    </div>

    <!-- ====== desktop + mobile mode ===== -->

    <div class="content_holder">
      <div class="info_holder">
        <div class="left_pannel order-2 order-md-1">
          <div class="d-none d-md-flex align-items-center justify-content-between w-100">
            <svg-icon src="/assets/images/bestwallet_modal/bestwallet_logo.svg" [svgStyle]="{ 'width.px': 100, 'height.px': 100 }"></svg-icon>
            <div class="font-16 topInfo  text-black fw-bold">{{ 'nowallet_modal.wallet_desc' | translate }}</div>
          </div>
          <div class="info_content">
            <div class="d-flex align-items-center justify-content-between mt-3 mt-md-0">
              <ul>
                <li class="d-flex d-md-none">
                  <div class="bullet">1</div>
                  <div class="text-black fw-bold">{{ 'nowallet_modal.step_0' | translate }}</div>
                </li>
                <li class="d-none d-md-flex">
                  <div class="bullet">1</div>
                  <div class="text-black fw-bold">{{ 'nowallet_modal.step_1' | translate }}</div>
                </li>
                <li>
                  <div class="bullet">2</div>
                  <div class="text-black fw-bold">{{ 'nowallet_modal.step_2' | translate }}</div>
                </li>
                <li>
                  <div class="bullet">3</div>
                  <div class="text-black fw-bold">{{ 'nowallet_modal.step_3' | translate }}</div>
                </li>
              </ul>

              <div class="qr-cont d-none d-md-block">
                <img src="/assets/images/bestwallet_modal/presale_qrcode.svg" alt="qr" loading="lazy" class="qr-img" />
              </div>
            </div>

            <a href="{{presale_singular_link}}" target="_blank" type="button" class="btn btn-secondary  w-100 w-md-75 mx-auto mt-4 d-block d-md-none">{{ 'nowallet_modal.download_bw' | translate }}</a>
          </div>
        </div>
        <img src="/assets/images/bestwallet_modal/need_wallet_desktop.png" alt="qr" loading="lazy" class="right-img d-none d-md-block order-1 order-md-2" />
        <img src="/assets/images/bestwallet_modal/need_wallet_mobile.png" alt="qr" loading="lazy" class="right-img d-block d-md-none order-1 order-md-2" />
      </div>
    </div>
  </div>
</div>
